import { extendTheme } from '@chakra-ui/react';
import '@fontsource/ibm-plex-sans';

const myTheme = {
  fonts: {
    heading: `IBM Plex Sans, monospace`,
    body: `IBM Plex Sans, monospace`,
  },
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },

  components: {
    Input: {
      variants: {
        filled: {
          field: {
            borderRadius: 'md',
            borderColor: 'transparent',
            bg: 'whiteAlpha.100',
            _hover: {
              bg: 'whiteAlpha.200',
            },
            _focus: {
              bg: 'whiteAlpha.200',
              borderColor: 'brand.500',
            },
          },
        },
      },
    },
    Button: {
      baseStyle: {
        borderRadius: 'full',
        size: 'lg',
      },
      defaultProps: {
        variant: 'primary',
      },
      variants: {
        primary: {
          px: '12',
          bg: 'brand.500',
          _hover: {
            bg: 'brand.400',
          },
          color: 'white',
          _disabled: {
            bg: 'brand.700',
            color: 'whiteAlpha.700',
            opacity: '1',
            _hover: {
              bg: 'brand.800 !important',
            },
          },
        },
        secondary: {
          px: '12',
          border: '1px solid',
          borderColor: 'brand.500',
          _hover: {},
          color: 'white',
        },
      },
    },
    Menu: {
      baseStyle: {
        list: {
          p: 1,
          zIndex: 9999,
          bg: 'whiteAlpha.500',
          borderRadius: '12px',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
          backdropFilter: 'blur(25px)',
        },
        item: {
          bg: 'whiteAlpha.100',
          color: 'black',
          transition: 'all 0.2s ease-in-out',
          _focus: {
            bg: 'whiteAlpha.100',
          },
          _hover: {
            bg: 'brand.500',
            color: 'white',
            textDecoration: 'none',
            fontWeight: 'normal',
          },
          fontWeight: 'normal',
          fontSize: 'sm',
          borderRadius: '6px',
          zIndex: 9999,
        },
      },
    },
    Tabs: {
      defaultProps: {
        variant: 'primary',
        bg: 'red',
      },
      baseStyle: {
        tab: {
          borderRadius: 'full',
          transition: 'all 0.2s ease-in-out',
          _hover: {
            bg: 'whiteAlpha.300',
          },
        },
        tablist: {
          borderRadius: '8px',
          p: '0',
          mb: '4',

          display: 'inline-flex',
        },
        tabpanel: {
          p: '0',
        },
      },
      variants: {
        primary: {
          tab: {
            '&&': {
              position: 'relative',
              fontSize: { base: 'sm', md: 'sm' },
              fontWeight: 'medium',
              color: 'white',
              borderRadius: 'full',

              _selected: {
                bg: 'white',
                color: 'gray.900',
              },
              _hover: {},
              _focus: { boxShadow: 'none' },
              width: '100%',
              mx: '1',
              py: '2',
              letterSpacing: '0.3px',
              transition: 'all 0.14s ease-in-out 0s',
              ':first-of-type': {
                ml: '0',
              },
              ':last-of-type': {
                mr: '1',
              },
            },

            tabpanels: {
              p: '0',
            },
            tabpanel: {
              w: '100%',
              h: '100%',
              p: '0',
            },
          },
        },
      },
    },
  },
  colors: {
    brand: {
      900: '#315116',
      800: '#386014',
      700: '#447912',
      600: '#589e12',
      500: '#74c71b',
      400: '#91e036',
      300: '#b1ee68',
      200: '#d1f6a0',
      100: '#e7fbcc',
      50: '#f5fde8',
    },
    gray: {
      900: '#130515',
      800: '#19071d',
      700: '#200926',
      600: '#270b30',
      500: '#2e0d39',
      400: '#423744',
      300: '#89828a',
      200: '#a19ba1',
      100: '#d0cdd0',
      50: '#e7e6e8',
    },
  },
  styles: {
    global: {
      'html, body': {
        margin: 0,
        padding: 0,
        bg: '#000000',
        color: '#fafafa',
      },
    },
  },
};

export default extendTheme(myTheme);
